import {createSelectorCreator, defaultMemoize} from 'reselect';
import isShallowEqual from './isShallowEqual';

export default createSelectorCreator(
  defaultMemoize,
  isShallowEqual
);



/** WEBPACK FOOTER **
 ** ./src/app/helpers/createSelector.js
 **/